import { Feature, Plan, ProjectTemplate, UserLayer } from '@core/api';
import { AppConfig } from '@core/config';
import { SelectedGeoJSONFeature, SelectedRenderFeature } from '@shared/open-layers';

import { GeoJSONFeature } from '../models/feature.model';

export function toGeoJSONFeature({ id, geometry, properties, createdAt, updatedAt, propertyId }: Feature): GeoJSONFeature {
  return {
    id,
    type: 'Feature',
    geometry,
    properties: { ...properties, createdAt, updatedAt },
    propertyId,
    createdAt,
    updatedAt,
  };
}

export function convertUserLayerToPlan(layer: UserLayer, features: GeoJSON.Feature[] = []): Plan {
  return {
    ...layer,
    geojson: {
      type: 'FeatureCollection',
      features: features ? features : [],
    },
  };
}

export function isRenderFeatureSelected(feature: SelectedGeoJSONFeature | SelectedRenderFeature): feature is SelectedRenderFeature {
  return feature.type === 'RenderFeature';
}

export function isPlanReadonly(plan: Plan, templates: ProjectTemplate[], config: AppConfig) {
  const template = templates?.find((t) => t.id === plan?.subtype);

  return !plan || plan.readonly || !template || (config.featureFlags['lockSurveys'] && template.type === 'survey');
}
